import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AppServiceManager } from 'common/services/appServiceManager';
import { AuthService } from 'common/services/auth.service';
import { Configuration } from 'config/config';
import { BreadcrumbService } from '../breadcrumb.service';
import { IUser } from '../shared/Domains/IUser';
import { IPettyExpense } from '../shared/Domains/IPettyExpense'
import { IRole } from '../shared/Domains/role';
import { Router } from '@angular/router';
import { LanguageService } from 'app/LanguageService/Language.Service';
import { IBranch } from 'app/shared/Domains/branch';
import { WebcamImage } from 'ngx-webcam/src/app/modules/webcam/domain/webcam-image';
import { AppUtils } from 'common/services/app.util';
import {
  buildPettyExpenseTransactionPayload,
  extractCreatedPettyExpenseIds,
  pettyExpenseTransactionUrl,
  pettyExpenseUploadUrl,
} from 'common/services/petty-expense-payload.util';

interface IExpenseLine {
  id: string;
  type: string;
  amount: number;
  selectedUser: string;
  purchasedItems: string[];
  billType: string;
  description: string;
  image?: any;
}

interface IExpenseLinePayload {
  amount: number;
  type: string;
  date: Date;
  borrowerName?: string;
  accountHolderName?: string;
  accountHolderId?: string;
  isDeducted: boolean;
  borrowerId?: string;
  purchasedItem?: string;
  billType?: string;
  description?: string;
  user: string;
  branch: string;
  company: string;
  createdBy: string;
  modeOfPayment: string;
  scope: string;
  initiatedFrom: string;
  activityBy: string;
  subject: string;
  employee?: string;
}

@Component({
  selector: 'app-pettycashdialouge',
  templateUrl: 'pettycashdialouge.component.html',
  styleUrls: ['pettyCashdialouge.component.css']
})
export class PettyCashDialougeComponent implements OnInit {
  @Input() pettydialogVisibility: any;
  @Output() closePettyCashDialog = new EventEmitter<any>();
  @Input() isDataAdded: boolean;
  @Output() isDataAddedChange = new EventEmitter<boolean>();
  currentDate: string = new Date().toISOString().split('T')[0];
  user: IUser;
  loading: boolean;
  role: IRole;
  amount: number;
  selectedUser: string;
  purchasedItem: string;
  purchasedItems: string[];
  billType: string;
  description: string;
  paymentMode: string;
  expenseType: string;
  addPettyImage: any;
  uploadPettyImage: any;
  isShowAddPettyImage: boolean;
  webcamImage: WebcamImage = null;
  // tempUploadImage: any;
  pictureSelected: boolean;
  selectedExpenseLineIndex: number = null;
  expenseDate: any;
  paymentOptions = [];
  pettyExpenseDialogVisibility: boolean;
  pettyExpenses: IPettyExpense[];
  Users: any[];
  userOptions: any[];
  branch: IBranch;
  expenseTypeOptions: any[];
  usersOptions: any[];
  purchasedItemGroups: { title: string; items: { value: string; labelKey: string; inputId: string }[] }[];
  expenseLines: IExpenseLine[];
  submittingTransaction: boolean;
  today: string;
  constructor(
    private LanguageService: LanguageService,
    private messageService: MessageService,
    private breadcrumbService: BreadcrumbService,
    public config: Configuration,
    private router: Router,
    private appServiceManager: AppServiceManager,
  ) {
    this.breadcrumbService.setItems([
      { label: 'Petty Cash' }
    ]);

  }
  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("PettyCashComponent", label);
  }
  ngOnInit() {
    this.user = AuthService.getLoggedInUser();
    this.amount = 0;
    this.expenseType = "";
    this.purchasedItem = "";
    this.purchasedItems = [];
    this.billType = "";
    this.description = "";
    this.expenseDate = this.currentDate;
    this.submittingTransaction = false;
    this.userOptions = [{ label: "Select User", value: null }];
    this.expenseTypeOptions = [
      { label: "Select", value: null },
      { label: this.setLabel("rentLabel"), value: "Rent" },
      { label: this.setLabel("salaryLabel"), value: "Salary" },
      { label: this.setLabel("purchasingLabel"), value: "Purchasing" },
      { label: this.setLabel("lendingLabel"), value: "Lending" },
      { label: this.setLabel("billsLabel"), value: "Bills" },
      { label: this.setLabel("accountDeductedLabel"), value: "Account Deducted" },
      { label: this.setLabel("othersLabel"), value: "Others" },
    ];
    this.expenseLines = [this.createEmptyExpenseLine()];
    this.usersOptions = [{ label: "Select Name", value: null }];
    this.purchasedItemGroups = [
      {
        title: 'Stationary Item',
        items: [
          { value: 'Pen', labelKey: 'penLabel', inputId: 'pitem-pen' },
          { value: 'Pencel', labelKey: 'pencelLabel', inputId: 'pitem-pencel' },
          { value: 'Eraser', labelKey: 'eraserLabel', inputId: 'pitem-eraser' },
          { value: 'Scale', labelKey: 'scaleLabel', inputId: 'pitem-scale' },
          { value: 'Steppler', labelKey: 'stepplerLabel', inputId: 'pitem-steppler' },
          { value: 'Steppler Pins', labelKey: 'stepplerPinsLabel', inputId: 'pitem-steppler-pins' },
          { value: 'Paper Holding Pins', labelKey: 'paperHoldingPinsLabel', inputId: 'pitem-paper-holding-pins' }
        ]
      },
      {
        title: 'Foods',
        items: [
          { value: 'Pizza', labelKey: 'pizzaLabel', inputId: 'pitem-pizza' },
          { value: 'Burger', labelKey: 'burgerLabel', inputId: 'pitem-burger' },
          { value: 'Pasta', labelKey: 'pastaLabel', inputId: 'pitem-pasta' },
          { value: 'Biryani', labelKey: 'biryaniLabel', inputId: 'pitem-biryani' },
          { value: 'Pulao', labelKey: 'pulaoLabel', inputId: 'pitem-pulao' },
          { value: 'Desi Food', labelKey: 'desiFoodLabel', inputId: 'pitem-desi-food' }
        ]
      },
      {
        title: 'Tea',
        items: [
          { value: 'Coffee', labelKey: 'coffeeLabel', inputId: 'pitem-coffee' },
          { value: 'Green Tea', labelKey: 'greenTeaLabel', inputId: 'pitem-green-tea' },
          { value: 'Tea', labelKey: 'teaLabel', inputId: 'pitem-tea' }
        ]
      },
      {
        title: 'Drinks',
        items: [
          { value: 'Minarl Water', labelKey: 'mineralWaterLabel', inputId: 'pitem-minarl-water' },
          { value: 'Juice', labelKey: 'juiceLabel', inputId: 'pitem-juice' },
          { value: 'Cold Drinks', labelKey: 'coldDrinksLabel', inputId: 'pitem-cold-drinks' },
          { value: 'Energy Drinks', labelKey: 'energyDrinksLabel', inputId: 'pitem-energy-drinks' }
        ]
      },
      {
        title: 'Others',
        items: [
          { value: 'Air freshner', labelKey: 'airFreshnerLabel', inputId: 'pitem-air-freshner' },
          { value: 'Print Paper', labelKey: 'printPaperLabel', inputId: 'pitem-print-paper' },
          { value: 'Equipment Part', labelKey: 'equipmentPartLabel', inputId: 'pitem-equipment-part' }
        ]
      }
    ];
    this.paymentOptions = [
      { label: 'Cash - Reception', value: 'Cash-Reception' },
    ];
    this.paymentMode = "Cash-Reception";
    this.today = new Date().toISOString().split('T')[0];
    this.getUserByID();
    this.getBranch();
    this.getUserPettyExpenses();
    this.role = AuthService.getLoggedInRole();
    this.getAllUsers();

  }

  getUserByID() {
    this.appServiceManager.get(`branches/${AuthService.getLoggedInBranch() || this.user.branch}/users/${this.user._id}`).subscribe(res => {
      if (res) {
        this.user = res;
      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
      }
    },
      (error) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  getBranch() {
    this.branch = AuthService.getLoggedInCurrentBranch();
    if(this.branch){
      if (Array.isArray(this.branch.payments)) {
        this.branch.payments.forEach(payment => {
          const existingBank = this.paymentOptions.find(option => option.value === `${payment.type}-${payment.name}`);
          if (!existingBank) {
            this.paymentOptions.push({
              label: `${payment.type} - ${payment.name}`,
              value: `${payment.type}-${payment.name}`
            });
          }
        });
      }
    }
    if(!this.branch){
      this.appServiceManager.get('branches/' + this.user.branch).subscribe((res) => {
        if (res) {
          res.payments.forEach(payment => {
            const existingBank = this.paymentOptions.find(option => option.value === `${payment.type}-${payment.name}`);
            if (!existingBank) {
              this.paymentOptions.push({
                label: `${payment.type} - ${payment.name}`,
                value: `${payment.type}-${payment.name}`
              });
            }
          });
        } else {
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
        (error) => {
          this.messageService.clear();
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
        });
      }
  }

  getUserPettyExpenses() {
    const branchId = AuthService.getLoggedInBranch() || this.user.branch;
    this.appServiceManager.get(`branches/${branchId}/petty-expenses/users/${this.user._id}`).subscribe(res => {
      if (res) {
        this.pettyExpenses = Array.isArray(res) ? res : (res?.response ?? []);
      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
      }
    },
      (error) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  showAddExpensePopup() {
    this.pettyExpenseDialogVisibility = true;
    this.amount = 0;
    this.expenseType = "";
    this.purchasedItem = "";
    this.purchasedItems = [];
    this.billType = "";
    this.description = "";
    this.expenseDate = this.currentDate;
    this.expenseLines = [this.createEmptyExpenseLine()];
  }

  onPaymentModeChange(value: string) {
    this.paymentMode = value;
  }

  dropdownChange(e) {
    console.log(e);
    this.selectedUser = e.value;
  }

  expenseTypeDropdownChange(e) {
    console.log(e);
    this.expenseType = e.value;
  }

  createEmptyExpenseLine(): IExpenseLine {
    return {
      id: Math.random().toString(36).substring(2, 10),
      type: null,
      amount: null,
      selectedUser: null,
      purchasedItems: [],
      billType: "",
      description: "",
      image: null
    };
  }

  addExpenseLine() {
    this.expenseLines.push(this.createEmptyExpenseLine());
  }

  removeExpenseLine(index: number) {
    if (this.expenseLines.length === 1) {
      this.expenseLines[0] = this.createEmptyExpenseLine();
      return;
    }
    this.expenseLines.splice(index, 1);
  }

  onLineTypeChange(line: IExpenseLine) {
    line.selectedUser = null;
    line.purchasedItems = [];
    line.billType = "";
  }

  getLineInputId(line: IExpenseLine, baseId: string) {
    return `${line.id}-${baseId}`;
  }

  getTotalAmount() {
    return this.expenseLines.reduce((total, line) => {
      const lineAmount = Number(line.amount || 0);
      return total + (isNaN(lineAmount) ? 0 : lineAmount);
    }, 0);
  }

  getUserNameById(userId: string) {
    if (!userId || !this.Users || !this.Users.length) {
      return undefined;
    }
    const selected = this.Users.find(u => u._id === userId);
    return selected ? selected.name : undefined;
  }

  validateLines() {
    if (!this.expenseDate) {
      this.messageService.clear();
      this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Expense Date Not Selected.' });
      return false;
    }

    if (!this.expenseLines || this.expenseLines.length === 0) {
      this.messageService.clear();
      this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Please add at least one expense line.' });
      return false;
    }

    for (let i = 0; i < this.expenseLines.length; i++) {
      const line = this.expenseLines[i];
      const rowNo = i + 1;

      if (!line.type) {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: `Expense type is required in row ${rowNo}.` });
        return false;
      }

      if (!line.amount || line.amount <= 0) {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: `Amount must be greater than 0 in row ${rowNo}.` });
        return false;
      }

      if (line.type === 'Purchasing' && (!line.purchasedItems || line.purchasedItems.length === 0)) {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: `Please select purchased item(s) in row ${rowNo}.` });
        return false;
      }

      if ((line.type === 'Lending' || line.type === 'Account Deducted' || line.type === 'Salary') && !line.selectedUser) {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: `Please select user in row ${rowNo}.` });
        return false;
      }

      if (line.type === 'Bills' && !line.billType) {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: `Please select bill type in row ${rowNo}.` });
        return false;
      }

      if (line.type === 'Others' && !(line.description || '').trim()) {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: `Comment is required in row ${rowNo}.` });
        return false;
      }
    }

    const total = this.getTotalAmount();
    if (total > this.user.pettyCash) {
      this.messageService.clear();
      this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Not enough amount in balance for this transaction total.' });
      return false;
    }

    return true;
  }

  buildExpenseFromLine(line: IExpenseLine): IExpenseLinePayload {
    const selectedUserName = this.getUserNameById(line.selectedUser);
    const expense: IExpenseLinePayload = {
      amount: Number(line.amount),
      type: line.type,
      date: this.expenseDate,
      borrowerName: undefined,
      accountHolderName: undefined,
      accountHolderId: undefined,
      isDeducted: false,
      borrowerId: undefined,
      purchasedItem: line.type === 'Purchasing' ? line.purchasedItems.join(', ') : undefined,
      billType: line.type === 'Bills' ? line.billType : undefined,
      description: line.description || this.description,
      user: this.user._id,
      branch: this.user.branch,
      company: this.user.company,
      createdBy: this.user._id,
      modeOfPayment: this.paymentMode,
      scope: 'Petty Cash',
      initiatedFrom: 'Petty Cash Dialogue - Multi',
      activityBy: this.user.name,
      subject: line.type,
      employee: undefined
    };

    if (line.type === 'Lending') {
      expense.borrowerName = selectedUserName;
      expense.borrowerId = line.selectedUser;
    }

    if (line.type === 'Account Deducted') {
      expense.accountHolderName = selectedUserName;
      expense.accountHolderId = line.selectedUser;
    }

    if (line.type === 'Salary') {
      expense.employee = selectedUserName;
    }

    return expense;
  }

  postExpense(expense: IExpenseLinePayload): Promise<any> {
    return new Promise((resolve, reject) => {
      this.appServiceManager.post('pettyExpense', expense).subscribe(resolve, reject);
    });
  }

  async addPettyExpense() {
    if (this.submittingTransaction) {
      return;
    }

    if (!this.validateLines()) {
      return;
    }

    this.submittingTransaction = true;
    const linePayloads = this.expenseLines.map(line => this.buildExpenseFromLine(line));
    const lineImages = this.expenseLines.map(line => line.image);
    const branchId = AuthService.getLoggedInBranch() || this.user.branch;
    const transactionPayload = buildPettyExpenseTransactionPayload({
      date: this.expenseDate,
      modeOfPayment: this.paymentMode,
      description: this.description,
      user: this.user._id,
      branch: this.user.branch,
      company: this.user.company,
      createdBy: this.user._id,
      activityBy: this.user.name,
      lines: linePayloads,
    });

    const onSuccess = (createdIds: string[] = []) => {
      this.onBeforeDialogHide();
      this.pettyExpenseDialogVisibility = false;
      this.getUserByID();
      this.getUserPettyExpenses();
      this.amount = 0;
      this.expenseType = "";
      this.purchasedItem = "";
      this.purchasedItems = [];
      this.billType = "";
      this.description = "";
      this.expenseDate = this.currentDate;
      this.expenseLines = [this.createEmptyExpenseLine()];
      this.isDataAdded = true;
      this.isDataAddedChange.emit(this.isDataAdded);
      this.messageService.clear();
      this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Expenses added Successfully' });

      createdIds.forEach((id, index) => {
  const image = lineImages[index];

  if (image) {
    const file = AppUtils.base64ToFile(
      image,
      `${this.user.name}.png` + ":" + this.user.company + ":" + this.user.branch
    );
    this.uploadCustomerImage(file, id, true);
  }
});
    };

    this.appServiceManager.post(pettyExpenseTransactionUrl(branchId), transactionPayload).subscribe(
      (res) => {
        const createdIds = extractCreatedPettyExpenseIds(res);
        onSuccess(createdIds);
        this.submittingTransaction = false;
      },
      async (error) => {
        const shouldFallback = error && (error.status === 404 || error.status === 400 || error.status === 405);
        if (!shouldFallback) {
          this.submittingTransaction = false;
          this.messageService.clear();
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          return;
        }

        try {
          const createdIds: string[] = [];
          for (const lineExpense of linePayloads) {
            const response = await this.postExpense(lineExpense);
            if (response?.response?._id) {
              createdIds.push(response.response._id);
            }
          }
          onSuccess(createdIds);
        } catch (fallbackError) {
          this.messageService.clear();
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: fallbackError });
        } finally {
          this.submittingTransaction = false;
        }
      }
    );
  }

  getAllUsers() {
    this.Users = [];
    this.loading = true;
    this.appServiceManager.get('branches/' + this.user.branch + '/users').subscribe(
      (res) => {
        if (res.length > 0) {
          this.Users = res;
          this.setUserData(this.Users);
          console.log("All Users", this.Users);

        } else {
          this.Users = [];
          this.messageService.clear();
          this.messageService.add({
            severity: "info",
            summary: "Info Message",
            detail: "No Record Found",
          });
        }
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.messageService.clear();
        this.messageService.add({
          severity: "error",
          summary: "Error Message",
          detail: error,
        });
      }
    );
  }

  setUserData(Users) {

    this.Users.forEach((Users) => {
      this.userOptions.push({
        label: Users.name,
        value: Users._id,
      });
      this.usersOptions.push({
        label: Users.name,
        value: Users._id,
      });
    });
  }
  onBeforeDialogHide() {
    this.closePettyCashDialog.emit();
  }
  showAddProfileImage(type, index: number) {
    this.addPettyImage = type; // Upload | Cam
    this.selectedExpenseLineIndex = index;
    this.isShowAddPettyImage = true;
}

  hideAddProfileImage() {
    this.isShowAddPettyImage = false;
    this.selectedExpenseLineIndex = null;
  }

  handleImagefromNewProfile(webcamImage) {
    const selectedLine = this.expenseLines[this.selectedExpenseLineIndex];

    if (webcamImage && selectedLine) {
      selectedLine.image = webcamImage;
      this.webcamImage = null;
      this.hideAddProfileImage();
    }

    this.selectedExpenseLineIndex = null;
  }

  uploadCustomerImage(file: any, pettyExpensesId: string | Blob, isAddMode = false) {
    let formData: FormData = new FormData();
    if (file) {


      formData.append("pettyExpensesImage", file, file.name);
      formData.append("isThumb", "true");
      formData.append("pettyExpensesId", pettyExpensesId);
      formData.append("company", this.user.company);
      formData.append("branch", this.user.branch);
      formData.append("isAddMode", isAddMode.toString());

      this.appServiceManager.put(pettyExpenseUploadUrl(this.user.branch), formData)
        .subscribe(
          (res: any) => {
          },
          (error: any) => {
            this.messageService.clear();
            this.messageService.add({ severity: "error", summary: "Error Message", detail: error, });
          }
        );
    }
    this.pictureSelected = false;
  }


}
